import { render, staticRenderFns } from "./AkbankPos.vue?vue&type=template&id=f7ebe47c&scoped=true"
import script from "./AkbankPos.vue?vue&type=script&lang=js"
export * from "./AkbankPos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7ebe47c",
  null
  
)

export default component.exports